import React, { useEffect, useState } from "react";
import { IonApp, IonContent, IonPage } from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Business from "services/Business";
import EditEmployees from "components/mobile-components/CreateEmployees/EditEmployee";
import {
  setEditEmployeeData,
  setEmployeeData,
} from "redux/container/userSlice";

export default function UpdateEmployeePage() {
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const employeeData = useSelector((state) => state.user.editEmployeeData);
  const dispatch = useDispatch();

  let { id } = useParams();
  // const [employees, setEmployees] = useState({});
  const [empLoading, setEmpLoading] = useState(false);
  const [bazAIPostToTeamChat, setBazAIPostToTeamChat] = useState(
    employeeData?.baz_ai_post_to_team_chat
  );
  const getEmployees = async () => {
    if (!employeeData?.id) {
      setEmpLoading(true);
      let response = await Business.getEmployees(id);
      if (response.status === 200) {
        dispatch(setEditEmployeeData(response.results));
        setEmpLoading(false);
      } else {
        setEmpLoading(false);
      }
    }
  };

  useEffect(() => {
    getEmployees();
  }, []);
  const handleToggleChatChange = (e) => {
    const newValue = e.detail.checked;
    setBazAIPostToTeamChat(newValue);
    dispatch(
      setEmployeeData({
        ...employeeData,
        baz_ai_post_to_team_chat: newValue,
      })
    );
  };
  return (
    <IonApp>
      <IonPage>
        <IonContent>
          <BackButtonTitle title={ekkLanguage.createEmployees.updateEmployee} />
          <EditEmployees
            bazAIPostToTeamChat={bazAIPostToTeamChat}
            handleToggleChatChange={handleToggleChatChange}
          />
        </IonContent>
      </IonPage>
    </IonApp>
  );
}
